export function formatTime(duration: number, includeSeconds: boolean = true): string {
  const h = Math.floor(duration / 3600);
  const m = Math.floor((duration % 3600) / 60);
  const s = Math.floor((duration % 3600) % 60);

  return (
    (h > 0 || includeSeconds ? h.toString().padStart(2, '0') + ':' : '') +
    m.toString().padStart(2, '0') +
    (includeSeconds ? ':' + s.toString().padStart(2, '0') : '')
  );
}

export function formatTimeWithUnits(duration: number): string {
  const totalSeconds = Math.max(0, Math.floor(duration));
  const totalMinutes = Math.floor(totalSeconds / 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  if (h > 0) {
    return `${h}h ${m}m`;
  }

  return `${m}m`;
}
